import { getCssCustomProperty } from '../../../../../../../shared/helpers/get-css-custom-property';

type ColorScheme = {
    background: string;
    title: string;
    text: string;
    conference: string;
};

/**
 * Кэш цветов из CSS-переменных.
 * Если при первом вызове переменные недоступны — следующий вызов попробует получить их снова.
 * При добавлении поддержки динамической смены темы — добавить инвалидацию.
 */
const cachedColors: ColorScheme = {
    background: '#17171A',
    title: '',
    text: '',
    conference: '',
};

function hasEmptyValues(colors: ColorScheme): boolean {
    return Object.values(colors).some((value) => !value);
}

/**
 * Возвращает цвета из CSS-переменных.
 * Если в кэше есть пустые значения — пробует получить заново.
 */
export function getColors(): ColorScheme {
    // Если кэш есть И все значения валидны — возвращаем
    if (cachedColors && !hasEmptyValues(cachedColors)) {
        return cachedColors;
    }

    cachedColors.title = getCssCustomProperty('--orb-text-primary');
    cachedColors.text = getCssCustomProperty('--orb-text-tertiary');
    cachedColors.conference = getCssCustomProperty('--orb-text-disabled');

    return cachedColors;
}
